/**
 * Design System Tokens for Admin UI
 * White/clean theme with Tilly Green (sage) accent
 */

export const colors = {
  // Neutral
  white: '#FFFFFF',
  black: '#000000',
  transparent: 'transparent',

  // Backgrounds
  bg: '#F6F7F5', // Off-white base
  surface: '#FFFFFF', // Card/surface white
  surfaceRaised: '#F9FAF9', // Subtle elevation

  // Text
  textPrimary: '#1F2933', // Dark gray for primary text
  textSecondary: '#5F6B66', // Medium gray for secondary
  textMuted: '#8A948E', // Light gray for muted

  // Borders
  border: '#DADFD8', // Light neutral border

  // Primary Accent — Sage Green (Tilly Green)
  accent: '#7FA897', // Sage 500 (primary focus/highlights)
  accentHover: '#6E9686', // Sage 600 (hover state)
  accentActive: '#5E8675', // Sage 700 (pressed/active)
  accentLight: '#E6F0EB', // Sage 200 (background tint)
  accentLighter: '#F1F7F4', // Sage 100 (very subtle tint)

  // Semantic
  success: '#5FAF8E',
  warning: '#E3B341',
  error: '#D86A6A',
  danger: '#D86A6A',
  info: '#7FA897',
} as const;

export const fonts = {
  body: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  heading: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  mono: 'ui-monospace, Menlo, Monaco, "Cascadia Code", monospace',
} as const;

export const spacing = 8; // Base spacing unit (8px grid)
export const borderRadius = 12; // Consistent border radius
